import { Component } from '@angular/core';

@Component({
  selector: 'app-orgstruture',
  templateUrl: './orgstruture.component.html',
  styleUrls: ['./orgstruture.component.scss']
})
export class OrgstrutureComponent {

}
